var React = require('react');

function StreamlineLine18LayersShow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","key":0},[React.createElement("path",{"d":"M23.5 10.5l-11.5 5-11.5-5","key":0}),React.createElement("path",{"d":"M23.5 13.5l-11.5 5-11.5-5","key":1}),React.createElement("path",{"d":"M23.5 16.5l-11.5 5-11.5-5M12 12.5L.5 7.5l11.5-5 11.5 5z","key":2})]),React.createElement("g",{"key":1},React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z"}))]);
}

StreamlineLine18LayersShow.displayName = "StreamlineLine18LayersShow";

StreamlineLine18LayersShow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = StreamlineLine18LayersShow;

StreamlineLine18LayersShow.default = StreamlineLine18LayersShow;



//////////////////
// WEBPACK FOOTER
// ./src/shared/static/icons/streamline-line-18-layers-show.svg
// module id = 768
// module chunks = 0